// src/features/executive/overview/usedStyle.tsx
// Same rhythm as the other tabs: TabRoot/Section/HeroRow mirror
// performance/usedStyle, Row mirrors sales/usedStyle.
import { Box, styled } from '@mui/material'

export const TabRoot = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}))

export const Section = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
}))

// 4-col KPI hero row.
export const HeroRow = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: '1fr',
  alignItems: 'stretch',
  [theme.breakpoints.up('sm')]: { gridTemplateColumns: 'repeat(2, 1fr)' },
  [theme.breakpoints.up('md')]: { gridTemplateColumns: 'repeat(4, 1fr)' },
}))

// 2-col row.
export const Row = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: '1fr',
  alignItems: 'stretch',
  [theme.breakpoints.up('md')]: { gridTemplateColumns: 'repeat(2, 1fr)' },
}))
